import { ReactNode } from "react";
import Skeleton from "react-loading-skeleton";

interface SecondaryCardProps {
  title: ReactNode;
  description: ReactNode;
  cardClassname?: string;
  loading?: boolean;
}

const SecondaryCard = ({
  title,
  description,
  cardClassname = "",
  loading = false,
}: SecondaryCardProps) => {
  return (
    <div
      className={`relative font-inter border border-card-border backdrop-blur-[10px] px-6 py-8 flex flex-col
        gap-[14px] ${cardClassname}`}
    >
      <h3 className="text-base text-white font-normal leading-[20px]">
        {title}
      </h3>

      {loading ? (
        <div className="w-full">
          <Skeleton height={24} width="50%" />
        </div>
      ) : (
        <p className="text-white font-bold text-xl">{description}</p>
      )}
    </div>
  );
};

export default SecondaryCard;
